import React, {useRef, useImperativeHandle} from 'react';

import { Form } from "react-bootstrap";

export default React.forwardRef((props, ref) => {
  const selectRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getInputNode() {
      return selectRef.current;
    },
    getValue() {
      console.log('getval', props.column.key, selectRef.current.value);
      return {
        [props.column.key]: selectRef.current.value
      };
    }
  }));

  console.log('dropdown', props.options);

  return (
    <Form.Control as="select"
      ref={selectRef}
      className="selectpicker"
      defaultValue={props.value}
      onBlur={props.onCommit}
    >
      {props.options.map((name) =>
        <option
          key={name.id}
          value={name.value}
          title={name.title}
          onClick={props.onCommit}
        >
          {name.text || name.value}
        </option>
      )}
    </Form.Control>
  );
});
